var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpejderhytte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#746d51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.665,6.229,8.048,2.862a.5.5,0,0,0-.514,0L1.918,6.229a.5.5,0,0,0,.257.929.487.487,0,0,0,.256-.072l.28-.167a.666.666,0,0,0-.046.228.679.679,0,0,0,.68.679.68.68,0,0,0,0,1.36.68.68,0,1,0,0,1.359.68.68,0,1,0,0,1.359h8.836a.68.68,0,0,0,0-1.359.68.68,0,0,0,0-1.359.68.68,0,0,0,0-1.36.679.679,0,0,0,.624-.947l.346.207a.5.5,0,1,0,.514-.857Zm-7.431.914a1.146,1.146,0,0,1,.117-.006,1.549,1.549,0,0,1,1.007.443l.459.409-.531.372L6.9,8.018a.725.725,0,0,0-.687-.26l-.961.006A1.491,1.491,0,0,1,6.234,7.143Zm-1.688,1.5a.336.336,0,0,1-.3-.137.242.242,0,0,1,0-.244.367.367,0,0,1,.328-.168L6.411,8.07a.3.3,0,0,1,.217.09c.014.011.03.024.049.037l.382.3a2.019,2.019,0,0,1-.5.149l-2,0Zm3.515.3c-1,.584-2.106,1.04-2.781.053L6.7,8.94a4.169,4.169,0,0,0,1.018-.449,4.759,4.759,0,0,1,1.043-.469c.314-.019.484.117.507.247a.227.227,0,0,1-.052.171.53.53,0,0,1-.362.166h0a2.271,2.271,0,0,0-.77.328ZM10.039,8.9a1.055,1.055,0,0,1-.775.557,1.57,1.57,0,0,1-1.125-.2,2.013,2.013,0,0,1,.57-.293,1.1,1.1,0,0,0,.71-.232.652.652,0,0,0-.28-1.061,1.215,1.215,0,0,0-1.025.222L7.65,7.426a1.917,1.917,0,0,1,1.605-.311,1.278,1.278,0,0,1,.84.711A1.228,1.228,0,0,1,10.039,8.9Zm1.416-.4a.367.367,0,0,1-.327.168l-.692.008a1.559,1.559,0,0,0,.005-.557h.71a.338.338,0,0,1,.3.136A.244.244,0,0,1,11.455,8.5Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpejderhytte);
export default __webpack_public_path__ + "static/media/SPEJDERHYTTE.c43976eafbcbdc3881d48c458604e30e.svg";
export { ForwardRef as ReactComponent };